export default "__VITE_PUBLIC_ASSET__58acb989__"